export default "__VITE_ASSET__fff8e16b__"